import { BulkActionWrapperDialogProps, BulkActionDialog } from 'components/core/bulk-actions/BulkActionDialog'
import { C1DateTimePicker } from 'components/core/date-time-picker/C1DateTimePicker'
import { AppEntitlementUserBindingSearchFilter, AppEntitlementWithExpired } from 'pbts/c1/api/app/v1/app_entitlement'
import { Timestamp } from 'pbts/google/protobuf/timestamp'
import { FC, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

export const BulkEditGrantDurationDialog: FC<BulkActionWrapperDialogProps<AppEntitlementWithExpired>> = (
    { close, selections, setSelections, triggerFetchActionStatus },
) => {
    const intl = useIntl()
    const [deprovisionAt, setDeprovisionAt] = useState<Date>(new Date())

    return (
        <BulkActionDialog<AppEntitlementWithExpired>
            close={close}
            args={{
                oneofKind: 'setGrantExpirationAction',
                setGrantExpirationAction: {
                    filter: AppEntitlementUserBindingSearchFilter.create({
                        refs: selections.map((appEntWithExpired) => ({
                            appId: appEntWithExpired.appId,
                            appEntitlementId: appEntWithExpired.appEntitlementId,
                            appUserId: appEntWithExpired.appUserId,
                        })),
                    }),
                    deprovisionAt: deprovisionAt ? Timestamp.fromDate(deprovisionAt) : undefined,
                },
            }}
            selections={selections}
            setSelections={setSelections}
            title={<FormattedMessage
                id="bulk_action_edit_grant_duration_title"
                defaultMessage="Set expiration for {count} {count, plural, one {grant} other {grants}}"
                values={{ count: selections.length }}
            />}
            submitButtonText={<FormattedMessage id="bulk_action_edit_grant_duration_submit" defaultMessage="Update" />}
            triggerFetchActionStatus={triggerFetchActionStatus}
        >
            <C1DateTimePicker
                label={intl.formatMessage({
                    id: 'bulk_edit_grant_duration_expiry',
                    defaultMessage: 'Grant expiration date',
                })}
                value={deprovisionAt}
                onChange={(value: Date | null): void => setDeprovisionAt(value ?? new Date())}
                minDate={new Date()}
                autoFocus
            />
        </BulkActionDialog>
    )
}
